import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';

import React from 'react';
import ReactDOM from 'react-dom'
import Home from './components/home/home';
import Report from './components/reports/report';
import Tos from './components/template/tos';
import PrivacyPolicy from './components/template/privacyPolicy';
import CookiesPolicy from './components/template/cookiesPolicy';
import ReCAPTCHA from "react-google-recaptcha";

import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

import '../css/bootstrap.min.css';

const APPS = {
    Home,
    Report,
    Tos,
    PrivacyPolicy,
    CookiesPolicy
};
  
function renderAppInElement(el) {

  var App = APPS[el.id];
  if (!App) return;

  // get props from elements data attribute, like the post_id
  const props = Object.assign({}, el.dataset);

  ReactDOM.render(
		  <I18nextProvider i18n={i18n}>  
		  <App {...props} />
		  </I18nextProvider>, el);

}

var slides = document.getElementsByClassName('__react-root');
for(var i = 0; i < slides.length; i++)
{
  renderAppInElement(slides.item(i));
}

/*
var data = Array.prototype.slice.call(document.querySelector('.__react-root'));
data.forEach(renderAppInElement);

document
  .querySelectorAll('.__react-root')
  .forEach(renderAppInElement)*/